import { Text } from '@genial/components';
import { Box, Center } from 'native-base';

export const CustomerEndOfList = () => {
  return (
    <Box w="full" py="stack.xxxs">
      <Center>
        <Text textAlign="center" variant="regular" color="neutral.black" lineHeight="distant">
          Você chegou ao final da lista. Caso não tenha encontrado seu cliente,{'\n'}
          utilize o{' '}
          <Text
            textAlign="center"
            variant="semibold"
            color="brand.tertiary.principal"
            lineHeight="distant">
            CAMPO DE BUSCA
          </Text>{' '}
          acima para pesquisar.
        </Text>
      </Center>
    </Box>
  );
};
